
namespace RioERP.Masters {

    @Serenity.Decorators.registerClass()
    export class BrandAmbassadorSettingsDialog extends Serenity.EntityDialog<BrandAmbassadorSettingsRow, any> {
        protected getFormKey() { return BrandAmbassadorSettingsForm.formKey; }
        protected getIdProperty() { return BrandAmbassadorSettingsRow.idProperty; }
        protected getLocalTextPrefix() { return BrandAmbassadorSettingsRow.localTextPrefix; }
        protected getNameProperty() { return BrandAmbassadorSettingsRow.nameProperty; }
        protected getService() { return BrandAmbassadorSettingsService.baseUrl; }
        protected getDeletePermission() { return BrandAmbassadorSettingsRow.deletePermission; }
        protected getInsertPermission() { return BrandAmbassadorSettingsRow.insertPermission; }
        protected getUpdatePermission() { return BrandAmbassadorSettingsRow.updatePermission; }

        protected form = new BrandAmbassadorSettingsForm(this.idPrefix);

    }
}